import axios from "axios";

import { SERVICE_URL, STATUS_CODE, AI_BASE_URL, CLIENT_PORTAL_BASE_URL } from "common/Constants";

export const CALL_OUTLOOK_API = async (action, params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const url = `${SERVICE_URL}${action}${query ? `?${query}` : ""}`;
    const resp = await axios.get(url, {
      headers: { Insytsjwt: window.localStorage.getItem("token") || "" },
    });
    return resp.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const CALL_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    const { response } = resp.data;
    return response;
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

export const CALL_FEATCH_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    // const { status, response } = resp.data;
     return resp.data;
    
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

export const CALL_CLIENT_PORTAL_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${CLIENT_PORTAL_BASE_URL}${action}`,
      data: payload,
      headers: {
        Insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    return resp.data;
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

export const CALL_API_UPDATED = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${SERVICE_URL}${action}`,
      data: payload,
      headers: {
        Insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    return resp.data

  } catch (err) {
    throw err;
  }
};

export const CALL_AI_API = async (action, method, payload) => {
  try {
    const resp = await axios({
      method,
      url: `${AI_BASE_URL}${action}`,
      data: payload,
      headers: {
        Insytsjwt: window.localStorage.getItem("token") || "",
      },
    });
    const { status, response } = resp.data;
    if (status === STATUS_CODE.SUCCESS || status === true) return response;
    else throw {};
  } catch (err) {
    console.log(err);
    console.log(action);
    return err;
  }
};

